import { getAccessToken } from '@driftt/web-auth'
import { orgId as getOrgId } from 'app/modules/org/selectors'
import { SocketState, ChannelState } from './models'
import {
  PRESENCE_API_BASE,
  PRESENCE_WSS_BASE,
  MESSAGES_API_BASE,
  MESSAGES_WSS_BASE,
  WS_CHAT_USE_SHARDS,
  WS_LIVE_USE_SHARDS,
  WS_CHAT_BASE,
  WS_LIVE_BASE,
  WS_PUSH_BASE,
  WS_NUM_SHARDS,
  WS_WSS_PROTOCOL,
  WS_API_PROTOCOL,
} from 'constants/ResourcesConstants'
import {
  SocketCluster,
  SocketChannel,
  CHANNEL_STATES,
  AUTHENTICATE_FAILURE,
} from './constants'

const root = (state) => state.get('socket')
const socketsRoot = state => root(state).get('socket')
const byCluster = (state, { clusterName }) => socketsRoot(state).get(clusterName, SocketState())

export const getUserId = (state, props) => byCluster(state, props).userId
export const getUserIpAddress = (state, props) => byCluster(state, props).userIpAddress
export const getSessionToken = (state, props) => byCluster(state, props).sessionToken
export const isAuthenticated = (state) => !!getSessionToken(state)

export const didAuthenticationFail = (state, { clusterName }) => {
  return byCluster(state, { clusterName }).get('authenticateStatus') === AUTHENTICATE_FAILURE
}

export const channelsToJoin = (state, props) => {
  return byCluster(state, props).get('channels').valueSeq()
    .filter((channelState) => channelState.state === CHANNEL_STATES.ERRORED)
    .map((channelState) => channelState.channel)
}

export const getChannelName = (state, { clusterName, channelName }) => {
  switch (channelName) {
    case SocketChannel.USER: return `user:${getUserId(state, { clusterName })}`
    case SocketChannel.ORG_PUBLIC: return `org:${getOrgId(state)}`
    case SocketChannel.ORG_PRIVATE: return `private-org:${getOrgId(state)}`
    default: return channelName
  }
}

export const getChannel = (state, props) =>
  byCluster(state, props).getIn(['channels', props.channelName], ChannelState())

export const getSocketState = (state, { clusterName }) => {
  return byCluster(state, { clusterName }).get('state')
}

export const hasConnected = (state, { clusterName }) => {
  return byCluster(state, { clusterName }).get('hasConnected')
}

export const getTimeUntilReconnect = (state, { clusterName }) => {
  return byCluster(state, { clusterName }).get('timeUntilReconnect')
}

export const getChannelState = (state, { clusterName, channelName }) => {
  return getChannel(state, { clusterName, channelName }).get('state')
}

export const getWssBaseUrl = (state, { clusterName }) => {
  switch (clusterName) {
    case SocketCluster.MESSAGES:
      if (WS_CHAT_USE_SHARDS) {
        const orgId = getOrgId(state)
        const shardId = computeShardId(orgId)
        return `${WS_WSS_PROTOCOL}://${orgId}-${shardId}.${WS_CHAT_BASE}`
      } else {
        return MESSAGES_WSS_BASE
      }

    case SocketCluster.PUSH:
      const orgId = getOrgId(state)
      const shardId = computeShardId(orgId)
      return `${WS_WSS_PROTOCOL}://${orgId}-${shardId}.${WS_PUSH_BASE}`
  }
}

export const getApiBaseUrl = (state, { clusterName }) => {
  switch (clusterName) {
    case SocketCluster.MESSAGES:
      if (WS_CHAT_USE_SHARDS) {
        const orgId = getOrgId(state)
        const shardId = computeShardId(orgId)
        return `${WS_API_PROTOCOL}://${orgId}-${shardId}.${WS_CHAT_BASE}`
      } else {
        return MESSAGES_API_BASE
      }

    case SocketCluster.PUSH:
      const orgId = getOrgId(state)
      const shardId = computeShardId(orgId)
      return `${WS_API_PROTOCOL}://${orgId}-${shardId}.${WS_PUSH_BASE}`
  }
}

export const getAuthParams = (state) => {
  return {
    access_token: getAccessToken(),
  }
}

const computeShardId = (orgId) => {
  return orgId % WS_NUM_SHARDS
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/socket/selectors.js